import React from 'react'
import "./FeaturedProducts.css"
import {AiFillStar} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

function FeaturedProducts({id, data}: any) {
  const navigate = useNavigate();
  return (
    <div className='hd-prod-card' onClick={() => navigate("/product/" + id)}>
        <div className="hd-prod-thumbnail">
            <img src={data.img.data[0].attributes.url} alt="" />
        </div>
        <div className="hd-prod-details">
            <span className="name">{data.title}</span>
            <span className="price">&#8377;{data.price}</span>
            <div className='rating'>
                <AiFillStar style={{color: "gold"}}/>
                <AiFillStar style={{color: "gold"}}/>
                <AiFillStar style={{color: "gold"}}/>
                <AiFillStar style={{color: "gold"}}/>
                <AiFillStar style={{color: "gold"}}/>
            </div>
        </div>
    </div>
  )
}

export default FeaturedProducts
